module.exports = __webpack_public_path__ + "img/icon-arrow-left-featured.f1665b69.svg";